module.exports = {"accueil":"Accueil","mes_demandes":"Mes demandes","mon_compte":"Mon compte","deconnexion":"Déconnexion","application_consommateur":"Application consommateur"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/default/lang/fr/home/template.lang.json
// module id = TChs
// module chunks = 1